import AccountsServices from '@/services/accounts'
import UsersServices from '@/services/users'
import LocalStorageUtils from '@/utils/localStorageUtils'
import AvatarUtils from '@/utils/avatarUtils'
import EnvironmentUtils from '@/utils/environmentUtils'

const getDefaultState = () =>
{
    return {
        accountId: -1,
        isLogged: false,
        username: '',
        firstName: '',
        lastName: '',
        isFemale: undefined,
        email: '',
        profilePictureUrl: '',
        token: '', // JWT used for authentication.
        hasBeenFetched: false,
        isGodMod: false,
        settings: {},
        ownedStore: null,
        privileges: {},
        oneSignalUserId: '',
        tags: {},
        meta: {}
    }
}

export default
{
    namespaced: true,
    
    state: getDefaultState(),

    mutations:
    {
        resetState (state)
        {
            Object.assign(state, getDefaultState())
        },

        saveTags (state)
        {
            console.log('Saving account tags')
            UsersServices.updateUser(EnvironmentUtils.cityId, {tags: state.tags})
        },

        saveSettings (state)
        {
            console.log('Saving account settings')
            AccountsServices.updateAccountSettings(state.token, state.settings)
        },

        setContext (state, user)
        {
            const setProp = propName =>
            {
                if (user.hasOwnProperty(propName))
                {
                    state[propName] = user[propName]
                }
            }

            user.profilePictureUrl = user.profilePictureUrl || state.profilePictureUrl || AvatarUtils.generateRandomAvatarUrl(user.accountId || state.accountId)

            setProp('accountId')
            setProp('isLogged')
            setProp('username')
            setProp('firstName')
            setProp('lastName')
            setProp('isFemale')
            setProp('token')
            setProp('email')
            setProp('profilePictureUrl')
            setProp('settings')
            setProp('ownedStore')
            setProp('hasBeenFetched')
            setProp('isGodMod')
            setProp('privileges')
            setProp('oneSignalUserId')
            setProp('tags')
            setProp('meta')
        },
    },

    actions:
    {
        async fetchUserInformationFromToken (context, { token, cityId })
        {
            context.commit('setContext', {token})

            let user, userSettings, userStore
            try
            {
                user = await AccountsServices.getAccount(token)
                userSettings = await AccountsServices.getAccountSettings(token)
                userStore = await AccountsServices.getAccountStore(token)
            }
            catch (e)
            {
                if (e.response && e.response.status == '401')
                {
                    return console.warn('Cannot login to account with token ', token, ', possibly expired.')
                }
                if (e.response && e.response.status == '404')
                {
                    return console.warn('Account not found')
                }
                else throw e
            }

            await this.dispatch('cities/fetchAdministratorAccount', { cityId, token, accountId: user.id })
            if (userStore)
            {
                await this.dispatch('stores/fetchStoreNotificationQuota', { cityId, storeId: userStore.id, token })
            }

            user.token = token
            user.accountId = user.id
            user.isLogged = true
            user.hasBeenFetched = true
            user.settings = userSettings
            user.ownedStore = userStore
            user.privileges = this.getters.cities.getAccountPrivileges({ cityId, accountId: user.id })
            await context.commit('setContext', user)
            
            LocalStorageUtils.token = token
        },

        logout (context)
        {
            context.commit('resetState')
            LocalStorageUtils.token = null
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/user.js